import axios from '../../../utils/axios';
import { filter, map } from 'lodash';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const API_URL = '/api/data/eCommerce/ProductsData';

interface Product {
  id: number;
  qty: number;

  // add other properties as needed
}

interface Filters {
  category: string;
  color: string;
  gender: string;
  price: string;
  rating: string;
}

interface EcommerceState {
  products: Product[];
  productSearch: string;
  sortBy: string;
  cart: Product[];
  total: number;
  filters: Filters;
  error: string;
  currentFilter?: string;
}

const initialState: EcommerceState = {
  products: [],
  productSearch: '',
  sortBy: 'newest',
  cart: [],
  total: 0,
  filters: {
    category: 'All',
    color: 'All',
    gender: 'All',
    price: 'All',
    rating: '',
  },
  error: '',
};

export const EcommerceSlice = createSlice({
  name: 'ecommerce',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action: PayloadAction<string>) {
      state.error = action.payload;
    },

    // GET PRODUCTS
    getProducts(state, action: PayloadAction<Product[]>) {
      state.products = action.payload;
    },
    SearchProduct(state, action: PayloadAction<string>) {
      state.productSearch = action.payload;
    },
    setVisibilityFilter(state, action: PayloadAction<string>) {
      state.currentFilter = action.payload;
    },

    //  SORT  PRODUCTS
    sortByProducts(state, action: PayloadAction<string>) {
      state.sortBy = action.payload;
    },

    //  SORT  PRODUCTS
    sortByGender(state, action: PayloadAction<{ gender: string }>) {
      state.filters.gender = action.payload.gender;
    },

    //  SORT  By Color
    sortByColor(state, action: PayloadAction<{ color: string }>) {
      state.filters.color = action.payload.color;
    },

    //  SORT  By Color
    sortByPrice(state, action: PayloadAction<{ price: string }>) {
      state.filters.price = action.payload.price;
    },

    //  FILTER PRODUCTS
    filterProducts(state, action: PayloadAction<{ category: string }>) {
      state.filters.category = action.payload.category;
    },

    //  FILTER Reset
    filterReset(state) {
      state.filters.category = 'All';
      state.filters.color = 'All';
      state.filters.gender = 'All';
      state.filters.price = 'All';
      state.sortBy = 'newest';
    },

    // ADD TO CART
    addToCart(state, action: PayloadAction<Product>) {
      const product = action.payload;
      state.cart = [...state.cart, product];
    },

    // qty increment
    increment(state, action: PayloadAction<number>) {
      const productId = action.payload;
      const updateCart = map(state.cart, (product) => {
        if (product.id === productId) {
          return {
            ...product,
            qty: product.qty + 1,
          };
        }

        return product;
      });

      state.cart = updateCart;
    },

    // qty decrement
    decrement(state, action: PayloadAction<number>) {
      const productId = action.payload;
      const updateCart = map(state.cart, (product) => {
        if (product.id === productId) {
          return {
            ...product,
            qty: product.qty - 1,
          };
        }

        return product;
      });

      state.cart = updateCart;
    },

    // delete Cart
    deleteCart(state, action: PayloadAction<number>) {
      const updateCart = filter(state.cart, (item) => item.id !== action.payload);
      state.cart = updateCart;
    },
  },
});

export const {
  hasError,
  getProducts,
  SearchProduct,
  setVisibilityFilter,
  sortByProducts,
  filterProducts,
  sortByGender,
  increment,
  deleteCart,
  decrement,
  addToCart,
  sortByPrice,
  filterReset,
  sortByColor,
} = EcommerceSlice.actions;

export const fetchProducts = () => async (dispatch: any) => {
  try {
    const response = await axios.get(API_URL);
    dispatch(getProducts(response.data));
  } catch (error: any) {
    dispatch(hasError(error.message));
  }
};


export default EcommerceSlice.reducer;
